import React from "react";
import { MainNavbar } from "@/components/navbar/MainNavbar";

export function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col">
      <MainNavbar />
      <div className="flex-1">{children}</div>
    </div>
  );
}
